import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  updateFilters,
  fetchSuccess,
  alertAlertCountSuccess,
  fetchFailure,
  downloadSuccess,
  downloadFailure,
  alertShipmentTypes,
  bulkUpdateResponse,
  bulkUpdateFilterSuccess,
  bulkUpdateFilterFailure,
} from "../actions/alertsShipment";
import {
  fetchSmartAlertsEndPoint,
  bulkUpdateSmartAlertEndPoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";
import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";


function* fetchAlertSaga(action) {
  const filters = action.payload;
  const levels = yield select((state) => state.alertsShipment.data.level);
  const statusList = yield select((state) => state.alertsShipment.data.statuses);
  function checkLabel(selectedLabel) {
    return filters.level[selectedLabel] === true;
  }
  function checkStatusLabel(selectedLabel) {
    return filters.status[selectedLabel] === true;
  }

  try {
    yield put(updateFilters(filters));
    let alertResponses;

    if (filters.isLoaded) {
      alertResponses = yield all([call(fetchAlertAPI, filters)]);
    } else {
      alertResponses = yield all([
        call(fetchAlertAPI, filters),
      ]);
    }
    if (filters.isLoaded) {
      yield put(
        fetchSuccess({
          list: {
            level: levels.map((level) => ({
              ...level,
              value: checkLabel(level.label),
            })),
            statuses: filters.status,
            alerts: alertResponses[0].hasOwnProperty("data")
              ? alertResponses[0].data
              : [],
          },
          bulkUpdate: {
            organizations: [],
            locations: [],
          },
        })
      );
    } else {
      const pd = {
        list: {
          level: levels.map((level) => ({
            ...level,
            value: checkLabel(level.label)
          })),
          alerts: alertResponses[0].hasOwnProperty("data")
            ? alertResponses[0].data
            : [],
        },
      } 
      yield put(
        fetchSuccess(pd)
      );
    }

    const severityCount = alertResponses[0].data.reduce((acc, alert) => {
      acc[alert.severity] = (acc[alert.severity] || 0) + 1;
      return acc;
    }, {});
    let warningCount = 0;
    let errorCount = 0;
    let criticalcount = 0;
    if (severityCount) {
      warningCount =
        severityCount?.Warning !== undefined ? severityCount?.Warning : 0;
      criticalcount =
        severityCount?.Critical !== undefined ? severityCount?.Critical : 0;
      errorCount =
        severityCount?.Error !== undefined ? severityCount?.Error : 0;
    }

    yield put(
      alertAlertCountSuccess({
        total: alertResponses[0].hasOwnProperty("count")
          ? alertResponses[0].count
          : 0,
          new: alertResponses[0].hasOwnProperty("New")
          ? alertResponses[0].New
          : 0,
        warning: warningCount,
        error: criticalcount + errorCount,
      })
    );
  } catch (error) {
    yield put(fetchFailure(error.message));
  }
}

function alertFilterbyfilters(filters) {
  let selectionFilters = [];
  if (filters.status !== null && filters.status !== "") {
    const selectedStatuses = Object.entries(filters.status)
      .filter((status) => status[1] === true)
      .map((status) => status[0]);

    const statusQuery = [];
    filters.status.forEach((selectedStatus) => {
      if (selectedStatus.text === "New" && selectedStatus.value === true) {
        statusQuery.push(
          `(isacknowledged eq 'false') AND (iscleared eq 'false') AND (state eq null)`
        );
      }

      if (
        selectedStatus.text === "Acknowledged" &&
        selectedStatus.value === true
      ) {
        statusQuery.push(`(isacknowledged eq 'true') AND (iscleared eq 'false') AND (state eq null)`);
      }

      if (selectedStatus.text === "Resolved" && selectedStatus.value === true) {
        statusQuery.push(`(iscleared eq 'true') AND (state eq null)`);
      }
      if (
        selectedStatus.text === "Auto Resolved" &&
        selectedStatus.value === true
      ) {
        statusQuery.push(`(state eq 'SYSTEM_NEW_CONDITION_CLEARED')`);
      }
    });
    if (statusQuery?.length > 0) {
      selectionFilters.push(`(${statusQuery.join(" OR ")})`);
    }
  }

  if (filters.level !== null && filters.level !== "") {
    const selectedlevels = Object.entries(filters.level)
      .filter((level) => level[1] === true)
      .map((level) => level[0]);

    const levelsQuery = [];
    if (selectedlevels.length === 0) {
      if (filters.level.toLowerCase() === "critical") {
        levelsQuery.push(`(severity LIKE 'Critical')`);
      } else if (filters.level.toLowerCase() === "warning") {
        levelsQuery.push(`((severity LIKE 'Warning') OR (severity LIKE 'Major'))`);
      } else if (filters.level.toLowerCase() === "alert") {
        levelsQuery.push(`(severity LIKE 'Alert')`);
      } else if (filters.level.toLowerCase() === "notification") {
        levelsQuery.push(`((severity LIKE 'Notification') OR (severity LIKE 'Minor'))`);
      }
    } else {
      selectedlevels.forEach((selectedlev) => {
        if (selectedlev.toLowerCase() === "critical") {
          levelsQuery.push(`(severity LIKE 'Critical')`);
        } else if (selectedlev.toLowerCase() === "warning") {
          levelsQuery.push(`((severity LIKE 'Warning') OR (severity LIKE 'Major'))`);
        } else if (selectedlev.toLowerCase() === "alert") {
          levelsQuery.push(`(severity LIKE 'Alert')`);
        } else if (selectedlev.toLowerCase() === "notification") {
          levelsQuery.push(`((severity LIKE 'Notification') OR (severity LIKE 'Minor'))`);
        }
      });
    }
    if (levelsQuery.length > 0) {
      selectionFilters.push(`(${levelsQuery.join(" OR ")})`);
    }
  }


  // Rest of your filter logic remains the same
  if (filters.subject !== null && filters.subject !== "") {
    selectionFilters.push(
      `((name LIKE '${filters.subject}') OR (description LIKE '${filters.subject}') OR ($/metadata/battery eq '${filters.subject}') OR (condition LIKE '${filters.subject}') OR ($/metadata/devicename eq '${filters.subject}'))`
    );
  }


  if (filters.lastUpdated !== null && filters.lastUpdated !== "") {
    if (filters.lastUpdated.length > 0) {
      const startDate = new Date(filters.lastUpdated[0]);
      const endDate = new Date(filters.lastUpdated[1]);
      const filterData = `'${startDate.getFullYear()}-${startDate.getMonth() + 1
        }-${startDate.getDate()}T00:00','${endDate.getFullYear()}-${(
          endDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${endDate.getDate()}T23:59'`;
      selectionFilters.push(`(lastupdated between(${filterData}))`);
    }
  }
  return selectionFilters;
}

async function fetchAlertAPI(filters) {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    filter: {
      $sort: filters.sort,
      $limitnumber: filters.limitnumber,
      $pagenumber: filters.pagenumber,
    },
  };

  const selectionFilters = alertFilterbyfilters(filters);
  selectionFilters.push(`($/metadata/shipmentid eq '${filters.shipmentid}')`)
  if (selectionFilters.length > 0) {
    const filter = selectionFilters.join(" AND ");
    body = {
      ...body,
      filter: {
        ...body.filter,
        $selection: `${filter}`,
      },
    };
  }

  const response = await fetch(fetchSmartAlertsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!response.ok) return [];

  return response.json();
}
function* bulkUpdateSaga(action) {
  try {
    const bulkUpdate = yield select((state) => state.alertsShipment.bulkUpdate);
    const total = action?.payload?.length;
    const newData = bulkUpdate.fields;
    yield call(
      bulkUpdateAPI,
      action.payload,
      newData.status
    );
    yield put(
      bulkUpdateResponse({
        isActive: true,
        message: "Bulk edit",
        description: `${total} alerts resolved successfully`,
      })
    );
  } catch (error) {
    yield put(
      bulkUpdateResponse({
        type: "error",
        isActive: true,
        message: "Bulk edit",
        description: `Something went wrong`,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      })
    );
  }
}

async function bulkUpdateAPI(resourceidentifiers, status) {
  let smartalert = {};
  if (status !== null && status !== "") {
    switch (status) {
      case "new":
        smartalert = {
          isacknowledged: false,
          iscleared: false,
        };
        break;
      case "acknowledged":
        smartalert = {
          isacknowledged: true,
          iscleared: false,
        };
        break;
      case "resolved":
        smartalert = {
          isacknowledged: false,
          iscleared: true,
        };
        break;
      default:
        break;
    }
  }
  const response = await fetch(bulkUpdateSmartAlertEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      resourceidentifiers,
      smartalert: {
        ...smartalert,
        isdisabled: null,
      },
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");

  return response.json();
}
async function apiDownload(page_no = 0, shipmentid) {
  return fetch(fetchSmartAlertsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: {
        $selection: `($/metadata/shipmentid eq '${shipmentid}')`,
        $sort: [{ field: "createdon", order: "desc" }]
      },
      $pagenumber: page_no,
      $limitnumber: 500,
    }),
  }).then((response) => response.json());
}

function* downloadSaga(action) {
  try {
    let response;
    if (action.payload.page_no > 500) {
      let totalPages = 0;
      if (action.payload.page_no % 500 === 0) {
        totalPages = action.payload.page_no / 500;
      } else {
        totalPages = Math.floor(action.payload.page_no / 500) + 1;
      }

      response = yield all(
        [...Array(totalPages)].map((v, i) => call(apiDownload, i, action.payload.shipmentid))
      );
    } else {
      response = yield call(apiDownload, 0, action.payload.shipmentid);
    }
    if (Array.isArray(response)) {
      let allData = [];
      for (const element of response) {
        allData = [...allData, element.data];
      }
      JSONToCSVDownload(CSVFormat(allData), "alerts_shipment_download.csv");
      yield put(downloadSuccess(allData));
    } else {
      JSONToCSVDownload(CSVFormat(response.data), "alerts_shipment_download.csv");
      yield put(downloadSuccess([...response]));
    }
  } catch (error) {
    yield put(downloadFailure(error.message));
  }
}

const CSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => {
    let acknowledged = null;
    if (!json?.state) {
      if (json.isacknowledged === false && json.iscleared === false) {
        acknowledged = "New";
      } else if (json.isacknowledged === true && json.iscleared === false) {
        acknowledged = "Acknowledge";
      } else if (json.isacknowledged === false && json.iscleared === true) {
        acknowledged = "Resolved";
      }
    } else {
      acknowledged = "Auto Resolved";
    }
    return {
      id: json.id,
      subject: json.name,
      message: json.message,
      level: json.severity,
      state: acknowledged,
      deviceId: json.deviceid,
      lastUpdated: json.lastupdated,
    };
  });
};
function* bulkUpdateFilterSaga() {
  try {
    const bulkUpdate = yield select((state) => state.alertsShipment.bulkUpdate);
    const filters = bulkUpdate.fields;
    let alertResponses = yield ([call(fetchAlertAPI, filters)]);

    yield put(bulkUpdateFilterSuccess(alertResponses[0].count));
  } catch (error) {
    yield put(bulkUpdateFilterFailure());
  }
}

export function* FetchAlertShipmentSaga() {
  yield takeLatest(alertShipmentTypes.FETCH_REQUEST, fetchAlertSaga);
}
export function* BulkShipmentUpdateSaga() {
  yield takeLatest(alertShipmentTypes.BULK_UPDATE_SUBMIT, bulkUpdateSaga);
}

export function* BulkShipmentUpdateFilterSaga() {
  yield takeLatest(alertShipmentTypes.BULK_UPDATE_FILTER, bulkUpdateFilterSaga);
}

export function* AlertShipmentDownloadSaga() {
  yield takeLatest(alertShipmentTypes.DOWNLOAD_REQUEST, downloadSaga);
}

